<template>
  <v-container fluid fill-height align-start pa-0 class="pageWrap">
    <v-sheet class="contents-container main_bg">
      <i-card-vertical headerTitle="고객관리" device="web">
        <template v-slot:body>
          <!-- 고객 관리 상세1 -->
          <v-row no-gutters>
            <v-col md="12" lg="10" class="d-flex justify-space-between align-center">
              <span class="editor-title main_text--text">{{ '고객관리 상세' }}</span>
              <v-switch v-model="clientInfoData.useYn" disabled>
                <template v-slot:label>
                  <span v-if="clientInfoData != null" class="ml-2 main_text--text switch-label">{{ clientInfoData.useYn ? '사용' : '미사용' }}</span>
                </template>
              </v-switch>
            </v-col>
          </v-row>

          <v-row no-gutters class="mt-5" :key="clientInfoData.clntIdLeader">
            <v-col md="5" lg="3" class="pr-1">
              <span class="editor-label">대표법인</span>
              <v-text-field ref="clntNmLeader" v-model="clientInfoData.clntNmLeader" solo class="editor_bg" :readonly="true" disabled />
              <!-- <DxDropDownBox
                class="hidden-sm-and-down"
                ref="dropDownBoxRefClnt"
                width="100%"
                :value="clientInfoData.clntIdLeader"
                :data-source="[{ clntId: clientInfoData.clntIdLeader, clntNm: clientInfoData.clntNmLeader }]"
                stylingMode="filled"
                :drop-down-options="{ width: '600px' }"
                :defer-rendering="false"
                :placeholder="clientInfoData.clntNmLeader"
                display-expr="clntNm"
                value-expr="clntId"
              >
                <clientSelectGrid :width="'100%'" :height="'20%'" @selectedData="onGridSelectionChanged"> </clientSelectGrid>
              </DxDropDownBox> -->

              <!-- <v-text-field ref="clntNmLeader" v-model="clientInfoData.clntNmLeader" solo class="editor_bg" :readonly="true" /> -->
            </v-col>
            <v-col md="5" lg="3" class="pr-1">
              <span class="editor-label">고객사명</span>
              <v-text-field ref="clntNm" v-model="clientInfoData.clntNm" solo class="editor_bg" :readonly="true" disabled />
            </v-col>
            <v-col md="2" lg="4" class="pl-1">
              <span class="editor-label">사업자등록번호</span>
              <v-text-field ref="rpstNo" v-model="clientInfoData.rgstNo" solo class="editor_bg" :readonly="true" disabled />
            </v-col>
          </v-row>
          <v-row no-gutters class="mt-5">
            <v-col md="4" lg="3" class="pr-1">
              <span class="editor-label">대표자명</span>
              <v-text-field ref="rpstNm" v-model="clientInfoData.rpstNm" solo class="editor_bg" :readonly="true" disabled />
            </v-col>
            <v-col md="4" lg="3" class="pr-1">
              <span class="editor-label">고객 회원가입 구분</span>
              <v-text-field ref="minorNm" v-model="clientInfoData.minorNm" solo class="editor_bg" :readonly="true" disabled />
            </v-col>
            <v-col md="4" lg="3">
              <span class="editor-label">가입일자</span>
              <v-text-field ref="joinDt" v-model="clientInfoData.joinDt" solo class="editor_bg" :readonly="true" disabled />
            </v-col>
          </v-row>
          <v-row no-gutters class="mt-5">
            <v-col md="4" lg="3" class="pr-1">
              <span class="editor-label">전화번호</span>
              <v-text-field ref="telNo" v-model="clientInfoData.telNo" solo class="editor_bg" :readonly="true" disabled />
            </v-col>
            <v-col md="4" lg="3" class="pr-1">
              <span class="editor-label">이메일</span>
              <v-text-field ref="email" v-model="clientInfoData.email" solo class="editor_bg" :readonly="true" disabled />
            </v-col>
            <v-col md="4" lg="3">
              <span class="editor-label">업종</span>
              <v-text-field ref="detailCd" v-model="clientInfoData.detailNm" solo class="editor_bg" :readonly="true" disabled />
            </v-col>
          </v-row>
          <v-row no-gutters class="mt-5">
            <v-col md="6" lg="5" class="pr-1">
              <span class="editor-label">우편번호</span>
              <v-text-field ref="zipCd" v-model="clientInfoData.zipCd" solo class="editor_bg" :readonly="true" disabled />
            </v-col>
            <v-col md="12" lg="10" class="pr-1">
              <span class="editor-label">주소</span>
              <v-text-field ref="addrs1" v-model="clientInfoData.addrs1" solo class="editor_bg" :readonly="true" />
            </v-col>
            <v-col md="12" lg="10" class="pr-1">
              <span class="editor-label">상세주소</span>
              <v-text-field ref="addrs2" v-model="clientInfoData.addrs2" solo class="editor_bg" :readonly="true" />
            </v-col>
          </v-row>
          <!-- 고객관리 상세2 -->
          <v-row no-gutters class="mt-5">
            <v-col md="12" lg="10" class="d-flex justify-space-between align-center">
              <span class="editor-title main_text--text">{{ '사업장(공사)' }}</span>
              <v-switch v-model="companyUseYn">
                <template v-slot:label>
                  <span v-if="companyUseYn" class="ml-2 main_text--text switch-label">사용</span>
                  <span v-else class="ml-2 main_text--text switch-label">미사용</span>
                </template>
              </v-switch>
            </v-col>
          </v-row>

          <div v-if="companyInfoData.length > 0 && companyInfoData[0] !== null">
            <div v-for="(item, index) in companyInfoData" :key="index" class="client-manage-detail-second">
              <v-expansion-panels accordion class="mt-5">
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <span class="editor-title main_text--text">{{ item.compNm }}</span>
                    <template v-slot:actions>
                      <v-icon color="primary">$expand</v-icon>
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row no-gutters class="mt-3">
                      <v-col md="6" lg="5" class="pr-1">
                        <span class="editor-label">사업장(공사)명</span>
                        <v-text-field ref="compId" v-model="item.compNm" solo class="editor_bg" readonly />
                      </v-col>
                      <v-col md="6" lg="5" class="pr-1">
                        <span class="editor-label">대표자명</span>
                        <v-text-field ref="compNm" v-model="item.rpstNm" solo class="editor_bg" readonly />
                      </v-col>
                    </v-row>
                    <v-row no-gutters class="mt-3">
                      <v-col md="6" lg="5" class="pr-1">
                        <span class="editor-label">공사종류</span>
                        <v-text-field ref="constructNm" v-model="item.constructNm" solo class="editor_bg" readonly />
                      </v-col>
                      <v-col md="6" lg="5" class="pr-1">
                        <span class="editor-label">업종</span>
                        <v-text-field ref="detailNm" v-model="item.detailNm" solo class="editor_bg" readonly />
                      </v-col>
                    </v-row>
                    <v-row no-gutters class="mt-3">
                      <v-col md="4" lg="3" class="pr-1">
                        <span class="editor-label">우편번호</span>
                        <v-text-field ref="zipCd" v-model="item.zipCd" solo class="editor_bg" readonly />
                      </v-col>

                      <v-col md="8" lg="7">
                        <span class="editor-label">주소</span>
                        <v-text-field ref="addrs1" v-model="item.addrs1" solo class="editor_bg" readonly />
                      </v-col>
                    </v-row>
                    <v-row no-gutters class="mt-3">
                      <v-col md="12" lg="10" class="pr-1">
                        <span class="editor-label">상세주소</span>
                        <v-text-field ref="addrs2" v-model="item.addrs2" solo class="editor_bg" readonly />
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>
          </div>
          <div v-else class="no-data">데이터가 없습니다.</div>
        </template>
      </i-card-vertical>

      <i-card-right headerTitle :useBtnList="buttonUseList" @btnSearch="btnSearch(mainData)">
        <template v-slot:customBtn>
          <i-icon-button color="btn_text" :text="'목록으로'" height="92px" :icon="'back'" @click="btnCancel()" :appendDivider="true"></i-icon-button>
        </template>
      </i-card-right>
    </v-sheet>
  </v-container>
</template>

<script>
import { getClientManageCompanyDetail, getClientManageDetail } from '@/api/adminManagement/clientManage'
import iCardTop from '@/components/common/iCardTop.vue'
import iCardVertical from '@/components/common/iCardVertical.vue'
import baseview from '@/views/base/baseview.vue' //20220414 LYJ base page 추가
import DxDropDownBox from 'devextreme-vue/drop-down-box'
import ClientSelectGrid from '@/components/esgCommon/clientSelectGrid.vue'
export default {
  mixins: [baseview],
  name: 'ClientManageDetail',
  components: {
    'i-card-top': iCardTop,
    'i-card-vertical': iCardVertical,
    DxDropDownBox,
    ClientSelectGrid
  },
  data() {
    return {
      buttonUseList: ['btnSearch'],
      mainData: {},
      clientInfoData: {},
      companyInfoData: [],
      companyUseYn: true
    }
  },
  created() {},
  beforeMount() {},
  mounted() {
    // refresh 시 처리
    if (!this.$route.params.data) {
      this.$router.go(-1)
      return
    }
    if (!this.$route.params.data.__created__) {
      this.mainData = this.$route.params.data
      this.btnSearch(this.mainData)
    }
  },
  activated() {
    if (this.$route.params.data) {
      this.mainData = this.$route.params.data
      if (this.mainData.__created__) {
        this.initializeData()
      } else {
        this.btnSearch(this.mainData)
      }
    }
  },
  watch: {
    companyUseYn() {
      this.getClientManageCompanyDetail()
    }
  },
  computed: {
    mobileTrigger: function() {
      return this.width < 800
    }
  },
  methods: {
    //------------------------------------------
    //  고객관리 상세페이지 조회
    //------------------------------------------
    async btnSearch(param) {
      this.openLoading()

      this.clientInfoData = {
        clntId: '',
        clntNm: '',
        rpstNm: '',
        rgstNo: '',
        zipCd: '',
        addrs1: '',
        addrs2: '',
        telNo: '',
        email: '',
        detailCd: '',
        detailNm: '',
        joinDiv: '',
        minorNm: '',
        joinDt: '',
        useYn: ''
      }
      this.companyInfoData = []
      this.companyUseYn = true

      let params = {
        clntId: param.clntId,
        useYn: this.companyUseYn ? 'Y' : 'N'
      }
      try {
        const response = await getClientManageDetail(params, false)
        const response2 = await getClientManageCompanyDetail(params, true)

        if (response.useYn == 'Y') {
          response.useYn = true
        } else if (response.useYn == 'N') {
          response.useYn = false
        }
        this.clientInfoData = response
        this.clientInfoData.joinDt = this.formatDate(response.joinDt)
        if (response2.success) {
          this.companyInfoData = response2.list
        }
      } catch (error) {
        console.error('getClientManageDetail error catch >> ', error)
      } finally {
        this.endLoading()
      }
    },
    //------------------------------------------
    //  대표법인 선택
    //------------------------------------------
    async onGridSelectionChanged(e) {
      console.log('#### e', e)
      this.clientInfoData.clntIdLeader = e.clntId
      this.clientInfoData.clntNmLeader = e.clntNm
      console.log('#### this.clientInfoData', this.clientInfoData)
      this.$refs.dropDownBoxRefClnt.instance.close()
    },
    //------------------------------------------
    //  고객 사업장 검색
    //------------------------------------------
    async getClientManageCompanyDetail() {
      this.companyInfoData = []

      let params = {
        clntId: this.mainData.clntId,
        useYn: this.companyUseYn ? 'Y' : 'N'
      }
      try {
        const reponse = await getClientManageCompanyDetail(params, false)
        if (reponse.success) {
          this.companyInfoData = reponse.list
        }
      } catch (error) {
        console.error('getClientManageCompanyDetail error catch >> ', error)
      }
    },
    //------------------------------------------
    //  고객관리 목록 이동
    //------------------------------------------
    btnCancel() {
      this.$vToastify
        .prompt({
          body: this.$t('이전 페이지로 이동하시겠습니까?'),
          answers: { 예: true, 아니오: false }
        })
        .then(response => {
          if (response) {
            const toRouter = {
              name: 'ClientManage',
              params: {
                data: { flag: true }
              }
            }
            this.$router.push(toRouter)
            return
          }
        })
    },
    //------------------------------------------
    //  날짜 포맷
    //------------------------------------------
    formatDate(dateString) {
      return `${dateString.slice(0, 4)}.${dateString.slice(4, 6)}.${dateString.slice(6, 8)}`
    }
  }
}
</script>

<style lang="scss">
.comp-title {
  font-size: 20px;
  font-weight: bold;
}
.client-manage-detail-second {
  margin-bottom: 30px;
}
.no-data {
  display: flex;
  font-size: 16px;
  justify-content: center;
  align-items: center;
  height: 200px; /* or whatever height you prefer */
}
</style>
